import {
  ZapOff2X_default
} from "./chunk-3QUDZS25.mjs";
import {
  UserCustomerSupport_default
} from "./chunk-DXHMKARM.mjs";
import {
  UserCustomerSupport2X_default
} from "./chunk-DF6N5IWW.mjs";
import {
  UserUsers_default
} from "./chunk-4JTR6BBL.mjs";
import {
  UserUsers2X_default
} from "./chunk-HURYERSO.mjs";
import {
  Users_default
} from "./chunk-JP4TGROQ.mjs";
import {
  Users2X_default
} from "./chunk-2WSP7DZG.mjs";
import {
  Whatsapp_default
} from "./chunk-FJCXTVOQ.mjs";
import {
  Zap_default
} from "./chunk-YT5OV6EP.mjs";
import {
  TagLoyalty_default
} from "./chunk-GXH7HYEW.mjs";
import {
  Telephone_default
} from "./chunk-IEYJ5XTW.mjs";
import {
  Tool_default
} from "./chunk-EQPPN3EQ.mjs";
import {
  ToolSettings_default
} from "./chunk-BGYJGXUV.mjs";
import {
  ToolSettings2X_default
} from "./chunk-UGMOWUQ7.mjs";
import {
  User2X_default
} from "./chunk-TQIC57RT.mjs";
import {
  UserCheck_default
} from "./chunk-EI2LJMDR.mjs";
import {
  UserCheck2X_default
} from "./chunk-OOZSA3MC.mjs";
import {
  Star24_default
} from "./chunk-72SVJN65.mjs";
import {
  Stone_default
} from "./chunk-CFBAXAGR.mjs";
import {
  StoneAgent_default
} from "./chunk-G52KGFAA.mjs";
import {
  StoneAgentShakingHands_default
} from "./chunk-FNLQCRT2.mjs";
import {
  StoneAgentShakingHands2X_default
} from "./chunk-ZYXL2UJ2.mjs";
import {
  StoreShop_default
} from "./chunk-NVSJPNSD.mjs";
import {
  SwapHorizontal_default
} from "./chunk-W67M5SMB.mjs";
import {
  Tag_default
} from "./chunk-3EIZSSUX.mjs";
import {
  SignalContactless2X_default
} from "./chunk-BE74ZWPE.mjs";
import {
  SignalFormStar_default
} from "./chunk-DEBZRI2B.mjs";
import {
  SignalLoader_default
} from "./chunk-3LI3NHPE.mjs";
import {
  SignalPercent_default
} from "./chunk-EOONMJ7G.mjs";
import {
  SignalWifi2_default
} from "./chunk-CPYYBDEN.mjs";
import {
  SimCard_default
} from "./chunk-2N4CXBXB.mjs";
import {
  Sliders_default
} from "./chunk-SXCW5ALG.mjs";
import {
  SmartPhone_default
} from "./chunk-BNS4FSUD.mjs";
import {
  SecurityLock_default
} from "./chunk-CXJ7ZAHO.mjs";
import {
  SecurityLock2X_default
} from "./chunk-LB2ZYI4S.mjs";
import {
  SecurityShield_default
} from "./chunk-RNYYDCWR.mjs";
import {
  SecurityShield2X_default
} from "./chunk-XWINBVPP.mjs";
import {
  SendMessage_default
} from "./chunk-X6C5AWEA.mjs";
import {
  Share_default
} from "./chunk-IPEY52ML.mjs";
import {
  Shop2_default
} from "./chunk-5YFQE7UP.mjs";
import {
  SignalContactless_default
} from "./chunk-Y44TZQJ2.mjs";
import {
  RateDown2X_default
} from "./chunk-JMQAKY63.mjs";
import {
  ReceiptList43_default
} from "./chunk-5VPF6AYG.mjs";
import {
  ReclameAqui_default
} from "./chunk-55VOLLVB.mjs";
import {
  Rings_default
} from "./chunk-JLZ6RXSD.mjs";
import {
  RoundDollar_default
} from "./chunk-NQRUKPHU.mjs";
import {
  Scan_default
} from "./chunk-X6FTAKRI.mjs";
import {
  SecurityKey_default
} from "./chunk-5Z6SKCN3.mjs";
import {
  SecurityKey2X_default
} from "./chunk-66T35MMD.mjs";
import {
  Pounds_default
} from "./chunk-4NCGPHBS.mjs";
import {
  Puzzle_default
} from "./chunk-J56ZS4JG.mjs";
import {
  QrCode_default
} from "./chunk-ZWCGP44P.mjs";
import {
  QrCode2X_default
} from "./chunk-TN36JNUN.mjs";
import {
  QrCodePix_default
} from "./chunk-44BQPOND.mjs";
import {
  Question_default
} from "./chunk-ZPJVIZRR.mjs";
import {
  RaioX_default
} from "./chunk-FBXCOPKU.mjs";
import {
  RateDown_default
} from "./chunk-5443KGTW.mjs";
import {
  PlusCircle_default
} from "./chunk-FVNWSM4E.mjs";
import {
  Pos_default
} from "./chunk-74C7PZWA.mjs";
import {
  Pos2X_default
} from "./chunk-4JFY6RIZ.mjs";
import {
  PosCoil_default
} from "./chunk-DZT4DOO7.mjs";
import {
  PosQr_default
} from "./chunk-DC6WRLKE.mjs";
import {
  PosQr2X_default
} from "./chunk-HMP3WCI3.mjs";
import {
  PosReceiptList2X_default
} from "./chunk-7BX2QOCC.mjs";
import {
  PosSmall_default
} from "./chunk-BVAHMC7M.mjs";
import {
  PhoneOutgoing_default
} from "./chunk-UK3K5ZOL.mjs";
import {
  PhoneSmart2X_default
} from "./chunk-V4DTBVTC.mjs";
import {
  Pig_default
} from "./chunk-S6P4IOPF.mjs";
import {
  Pill_default
} from "./chunk-PJYKPFCC.mjs";
import {
  Pix_default
} from "./chunk-HWUINTJ7.mjs";
import {
  Play_default
} from "./chunk-FSEMBGFU.mjs";
import {
  PlayBorder_default
} from "./chunk-YYVBHXCB.mjs";
import {
  Plus_default
} from "./chunk-CV2HF6TM.mjs";
import {
  Phone_default
} from "./chunk-WLAF63SO.mjs";
import {
  Phone2X_default
} from "./chunk-Q7OBHONK.mjs";
import {
  PhoneCard_default
} from "./chunk-UIRI2P4C.mjs";
import {
  PhoneCard2X_default
} from "./chunk-FZ63IRGM.mjs";
import {
  PhoneChat_default
} from "./chunk-ZLQYNJKB.mjs";
import {
  PhoneChat2X_default
} from "./chunk-XKAG6VL3.mjs";
import {
  PhoneCheck_default
} from "./chunk-J7QDY5O4.mjs";
import {
  PhoneMobile_default
} from "./chunk-NPJXXRKZ.mjs";
import {
  Office2X_default
} from "./chunk-KI744QBE.mjs";
import {
  OneStars_default
} from "./chunk-5XHPNYUV.mjs";
import {
  OpenBook_default
} from "./chunk-XXDOZ747.mjs";
import {
  PapoDeBalcao_default
} from "./chunk-KMTIZXJE.mjs";
import {
  Pause_default
} from "./chunk-FA6SPCS5.mjs";
import {
  PaymentLink_default
} from "./chunk-YTZ3T3D3.mjs";
import {
  PeopleHandshake_default
} from "./chunk-WIPPT5DO.mjs";
import {
  PeopleQuestion_default
} from "./chunk-SHDVHUUP.mjs";
import {
  Money_default
} from "./chunk-KSORUW6L.mjs";
import {
  Money2X_default
} from "./chunk-YDP75624.mjs";
import {
  MoneyGrowth_default
} from "./chunk-DESTR6MS.mjs";
import {
  MoneyHand_default
} from "./chunk-JRJIN3QY.mjs";
import {
  MoneyHand24_default
} from "./chunk-S56Q6JEE.mjs";
import {
  MoneyHand2X_default
} from "./chunk-3XNXJXZ3.mjs";
import {
  MoneyTime_default
} from "./chunk-VGU7U4UA.mjs";
import {
  Office_default
} from "./chunk-YD27TQSJ.mjs";
import {
  Mail_default
} from "./chunk-SFM6FBOK.mjs";
import {
  Message_default
} from "./chunk-XL6V74EF.mjs";
import {
  Message2X_default
} from "./chunk-CUVGIAMR.mjs";
import {
  Minus_default
} from "./chunk-VR4CQBVK.mjs";
import {
  MinusCircle_default
} from "./chunk-PKWOXPNN.mjs";
import {
  MobileBanking_default
} from "./chunk-D4HDCH4F.mjs";
import {
  MobileCard_default
} from "./chunk-E5C7QEP7.mjs";
import {
  MobilePhone_default
} from "./chunk-YNPUHVGT.mjs";
import {
  LogoStone_default
} from "./chunk-NC6YYT3M.mjs";
import {
  LogoStone2X_default
} from "./chunk-NQ7Z7OBL.mjs";
import {
  LogoTon_default
} from "./chunk-NCVYSZZF.mjs";
import {
  LogoTonStone_default
} from "./chunk-RI4U2EEJ.mjs";
import {
  LogoWhatsapp_default
} from "./chunk-SACTCEUU.mjs";
import {
  LogoWhatsapp2X_default
} from "./chunk-AVMRN7N3.mjs";
import {
  LoyaltyHeart2X_default
} from "./chunk-LDHLOYMZ.mjs";
import {
  Machine_default
} from "./chunk-QB23QI5D.mjs";
import {
  Libras_default
} from "./chunk-GJTMRWVM.mjs";
import {
  LifeBuoy_default
} from "./chunk-WA2FPM57.mjs";
import {
  Link_default
} from "./chunk-UX7A4QEC.mjs";
import {
  Link2X_default
} from "./chunk-L2GAUUJD.mjs";
import {
  Lock_default
} from "./chunk-S2RP4X65.mjs";
import {
  Logo_default
} from "./chunk-WOK7DD7Y.mjs";
import {
  LogoRaioX_default
} from "./chunk-B2SF35FI.mjs";
import {
  LogoRaioX2X_default
} from "./chunk-OPO6IPZ5.mjs";
import {
  Heart24_default
} from "./chunk-D5QNU6ZF.mjs";
import {
  HelpInfo_default
} from "./chunk-3IROHHMG.mjs";
import {
  HelpInfo2X_default
} from "./chunk-AHOD6DVA.mjs";
import {
  Hospital_default
} from "./chunk-PASMUBKE.mjs";
import {
  Hospital2X_default
} from "./chunk-ZNLCWTDY.mjs";
import {
  Info_default
} from "./chunk-WMCHM7PU.mjs";
import {
  Invoice2_default
} from "./chunk-HUJ2EFO4.mjs";
import {
  Invoice22X_default
} from "./chunk-5UTCMWNO.mjs";
import {
  HandMoney_default
} from "./chunk-BVIP7ATY.mjs";
import {
  HandShake_default
} from "./chunk-NAT2JBXR.mjs";
import {
  HandShake2X_default
} from "./chunk-CCGZIIYY.mjs";
import {
  HandshakeSoft_default
} from "./chunk-FHQIE3LX.mjs";
import {
  HeadPhone_default
} from "./chunk-5ABOEKFL.mjs";
import {
  Headset_default
} from "./chunk-GUPUQKTI.mjs";
import {
  HealthFaceHappy_default
} from "./chunk-QFEWCDB3.mjs";
import {
  Heart_default
} from "./chunk-KLLTIQSU.mjs";
import {
  FormStar2X_default
} from "./chunk-JJXZZJ4C.mjs";
import {
  Gift_default
} from "./chunk-SEJAEZNA.mjs";
import {
  Global_default
} from "./chunk-R2C3KPA6.mjs";
import {
  Grid_default
} from "./chunk-QFWVBDTF.mjs";
import {
  Grid2_default
} from "./chunk-O6OHFB5W.mjs";
import {
  HandHeart_default
} from "./chunk-BV3NV2EW.mjs";
import {
  HandHeart2X_default
} from "./chunk-KLB7WIPJ.mjs";
import {
  HandHeartSoft_default
} from "./chunk-2XOOLHHL.mjs";
import {
  File_default
} from "./chunk-6ZXOOU7O.mjs";
import {
  File2X_default
} from "./chunk-GSEHBUPG.mjs";
import {
  FileTyped_default
} from "./chunk-HGJ7GCWK.mjs";
import {
  FinanceAndStone_default
} from "./chunk-AYN7W2FY.mjs";
import {
  FlipUp_default
} from "./chunk-LH335EX4.mjs";
import {
  FlipUp2_default
} from "./chunk-ZFV6E4PI.mjs";
import {
  FormHeart2X_default
} from "./chunk-V6MMFXX4.mjs";
import {
  FormStar_default
} from "./chunk-Y7S2IDHH.mjs";
import {
  ECart2X_default
} from "./chunk-7YI7P5ZU.mjs";
import {
  ECommerce_default
} from "./chunk-S4URD4E6.mjs";
import {
  Ecommerce2X_default
} from "./chunk-T3ICRGGG.mjs";
import {
  EconomicoValor_default
} from "./chunk-2MBTS7IQ.mjs";
import {
  Email_default
} from "./chunk-4EHCDENT.mjs";
import {
  Email2X_default
} from "./chunk-FFCCCOCA.mjs";
import {
  FaceHappy_default
} from "./chunk-ELXA35GJ.mjs";
import {
  FaceHappy2X_default
} from "./chunk-CTEYG6CK.mjs";
import {
  DollarPhone_default
} from "./chunk-YLAPBMP6.mjs";
import {
  DollarPhone2X_default
} from "./chunk-57KCE73Z.mjs";
import {
  DollarShield_default
} from "./chunk-LMKJIHTO.mjs";
import {
  DollarShield2X_default
} from "./chunk-KYYXO5TU.mjs";
import {
  DollarSign_default
} from "./chunk-RWBDNYAS.mjs";
import {
  DollarSign2X_default
} from "./chunk-NZCVGVRR.mjs";
import {
  DuoStars_default
} from "./chunk-5TQQN6IU.mjs";
import {
  ECart_default
} from "./chunk-YJFLIUVZ.mjs";
import {
  DateClock2X_default
} from "./chunk-3DM2U5TI.mjs";
import {
  DollarCircle_default
} from "./chunk-3S7FIIRJ.mjs";
import {
  DollarInvoicePay_default
} from "./chunk-XTLYDE5C.mjs";
import {
  DollarInvoicePay2X_default
} from "./chunk-OEBL2ZP3.mjs";
import {
  DollarOff_default
} from "./chunk-NGXDZTEU.mjs";
import {
  DollarOff2X_default
} from "./chunk-SJPNJXLI.mjs";
import {
  DollarPaymentLink_default
} from "./chunk-VZ5WLKDO.mjs";
import {
  DollarPaymentLink2X_default
} from "./chunk-V2B5LAD5.mjs";
import {
  Coupon_default
} from "./chunk-PA4E55LC.mjs";
import {
  CreditCard_default
} from "./chunk-W35O4EYQ.mjs";
import {
  CustomerSupport_default
} from "./chunk-3A6W3XS3.mjs";
import {
  CustomerSupport2X_default
} from "./chunk-6X6QSZQL.mjs";
import {
  Cutlery_default
} from "./chunk-IMQREMAN.mjs";
import {
  DateCalendar_default
} from "./chunk-XVNNE36U.mjs";
import {
  DateCalendar2X_default
} from "./chunk-X4K2ZLWD.mjs";
import {
  DateClock_default
} from "./chunk-SRNGG3TX.mjs";
import {
  Clock_default
} from "./chunk-KJ7K556I.mjs";
import {
  Clock24_default
} from "./chunk-QFUBD3EN.mjs";
import {
  Close_default
} from "./chunk-OO6NNUIG.mjs";
import {
  CloseRound_default
} from "./chunk-KLKOLCAY.mjs";
import {
  Cnn_default
} from "./chunk-G5PHOPC7.mjs";
import {
  Coil_default
} from "./chunk-56MVZKR6.mjs";
import {
  Contactless_default
} from "./chunk-DLWNLRA4.mjs";
import {
  ContactlessCard_default
} from "./chunk-LWMIBRGN.mjs";
import {
  CheckCircle_default
} from "./chunk-5BO2HB2F.mjs";
import {
  CheckPhone_default
} from "./chunk-QIW3OLQO.mjs";
import {
  CheckRound_default
} from "./chunk-TPRNSJMP.mjs";
import {
  ChevronDown_default
} from "./chunk-YUMHPO7E.mjs";
import {
  ChevronLeft_default
} from "./chunk-A2ON3OYH.mjs";
import {
  ChevronRight_default
} from "./chunk-JDXPIJVW.mjs";
import {
  ChevronRight2X_default
} from "./chunk-XTMHZSOQ.mjs";
import {
  ChevronUp_default
} from "./chunk-DDUFY7CY.mjs";
import {
  CentHand2X_default
} from "./chunk-LYXM6UWX.mjs";
import {
  ChartBar2_default
} from "./chunk-CKL7MREK.mjs";
import {
  ChartBar22X_default
} from "./chunk-4MRCNVIS.mjs";
import {
  ChartBar3_default
} from "./chunk-Q2WXIRLG.mjs";
import {
  ChartSmall_default
} from "./chunk-AYU72FUO.mjs";
import {
  ChartSmall2X_default
} from "./chunk-JO2BCZWX.mjs";
import {
  Check_default
} from "./chunk-EDT6HMPJ.mjs";
import {
  Check2X_default
} from "./chunk-PXW5TLCT.mjs";
import {
  CardIn2X_default
} from "./chunk-ALLJ4NIP.mjs";
import {
  CardStone_default
} from "./chunk-LOHSTI2T.mjs";
import {
  CardStone2X_default
} from "./chunk-FV3FUWZJ.mjs";
import {
  Cart_default
} from "./chunk-RC5MVRUR.mjs";
import {
  CashPhone_default
} from "./chunk-LODZSKP7.mjs";
import {
  CashRound_default
} from "./chunk-5WH4Q27D.mjs";
import {
  CentClock_default
} from "./chunk-I4LRLFH5.mjs";
import {
  CentClock2X_default
} from "./chunk-3XYTQNOL.mjs";
import {
  Calculator_default
} from "./chunk-XG6RSE4T.mjs";
import {
  Calculator2X_default
} from "./chunk-2UMERP3A.mjs";
import {
  Calendar_default
} from "./chunk-D4H3TGSK.mjs";
import {
  CardCredit_default
} from "./chunk-YMDY6FKL.mjs";
import {
  CardCredit2X_default
} from "./chunk-EARV44YX.mjs";
import {
  CardHand_default
} from "./chunk-Q4ZJZA4Q.mjs";
import {
  CardHand2X_default
} from "./chunk-UPJUIURY.mjs";
import {
  CardIn_default
} from "./chunk-WFULOOJ4.mjs";
import {
  BChartSmall_default
} from "./chunk-FLDHKHEO.mjs";
import {
  Bank_default
} from "./chunk-UBIULXV6.mjs";
import {
  Bank2X_default
} from "./chunk-WU26BRM4.mjs";
import {
  BatteryCharging_default
} from "./chunk-AK2KCIAF.mjs";
import {
  BlackQrCode_default
} from "./chunk-OM3MUOEC.mjs";
import {
  BookOpen_default
} from "./chunk-RLUGIYJO.mjs";
import {
  BookOpen2X_default
} from "./chunk-FDB4DZU2.mjs";
import {
  BoxGift_default
} from "./chunk-JGHWAZAR.mjs";
import {
  ArrowSwapHorizontal2X_default
} from "./chunk-OAYKY5SO.mjs";
import {
  ArrowUp_default
} from "./chunk-MFUXQSDK.mjs";
import {
  ArrowUpRight_default
} from "./chunk-XNFCEXFR.mjs";
import {
  AudioVideoPlayCircle_default
} from "./chunk-ZHMC742R.mjs";
import {
  AutoBus_default
} from "./chunk-O24PORQY.mjs";
import {
  AutoBus2X_default
} from "./chunk-CGE2AFGE.mjs";
import {
  AutoTruck_default
} from "./chunk-7RAB3T6J.mjs";
import {
  Award_default
} from "./chunk-VN5QIA22.mjs";
import {
  ArrowDown_default
} from "./chunk-P4JTSCIG.mjs";
import {
  ArrowDown2X_default
} from "./chunk-ADJJVDK2.mjs";
import {
  ArrowFillLeft_default
} from "./chunk-B6PRYGMK.mjs";
import {
  ArrowLeft_default
} from "./chunk-WNFVLKWB.mjs";
import {
  ArrowLeft2X_default
} from "./chunk-XZYBISXQ.mjs";
import {
  ArrowRight_default
} from "./chunk-LPDLEHDO.mjs";
import {
  ArrowRight2X_default
} from "./chunk-GQZZACY5.mjs";
import {
  ArrowSwapHorizontal_default
} from "./chunk-I7YJ6QZL.mjs";
import {
  Accelerator_default
} from "./chunk-Z6M33WCI.mjs";
import {
  Accelerator2X_default
} from "./chunk-LFN5W6JY.mjs";
import {
  AgentStone_default
} from "./chunk-NCDDPSQL.mjs";
import {
  Apps_default
} from "./chunk-4EJXYG6E.mjs";
import {
  Apps2X_default
} from "./chunk-R7SEIBT5.mjs";
import {
  __export
} from "./chunk-7P6ASYW6.mjs";

// src/stone/icons/index.ts
var icons_exports = {};
__export(icons_exports, {
  accelerator: () => Accelerator_default,
  accelerator2X: () => Accelerator2X_default,
  agentStone: () => AgentStone_default,
  apps: () => Apps_default,
  apps2X: () => Apps2X_default,
  arrowDown: () => ArrowDown_default,
  arrowDown2X: () => ArrowDown2X_default,
  arrowFillLeft: () => ArrowFillLeft_default,
  arrowLeft: () => ArrowLeft_default,
  arrowLeft2X: () => ArrowLeft2X_default,
  arrowRight: () => ArrowRight_default,
  arrowRight2X: () => ArrowRight2X_default,
  arrowSwapHorizontal: () => ArrowSwapHorizontal_default,
  arrowSwapHorizontal2X: () => ArrowSwapHorizontal2X_default,
  arrowUp: () => ArrowUp_default,
  arrowUpRight: () => ArrowUpRight_default,
  audioVideoPlayCircle: () => AudioVideoPlayCircle_default,
  autoBus: () => AutoBus_default,
  autoBus2X: () => AutoBus2X_default,
  autoTruck: () => AutoTruck_default,
  award: () => Award_default,
  bChartSmall: () => BChartSmall_default,
  bank: () => Bank_default,
  bank2X: () => Bank2X_default,
  batteryCharging: () => BatteryCharging_default,
  blackQrCode: () => BlackQrCode_default,
  bookOpen: () => BookOpen_default,
  bookOpen2X: () => BookOpen2X_default,
  boxGift: () => BoxGift_default,
  calculator: () => Calculator_default,
  calculator2X: () => Calculator2X_default,
  calendar: () => Calendar_default,
  cardCredit: () => CardCredit_default,
  cardCredit2X: () => CardCredit2X_default,
  cardHand: () => CardHand_default,
  cardHand2X: () => CardHand2X_default,
  cardIn: () => CardIn_default,
  cardIn2X: () => CardIn2X_default,
  cardStone: () => CardStone_default,
  cardStone2X: () => CardStone2X_default,
  cart: () => Cart_default,
  cashPhone: () => CashPhone_default,
  cashRound: () => CashRound_default,
  centClock: () => CentClock_default,
  centClock2X: () => CentClock2X_default,
  centHand2X: () => CentHand2X_default,
  chartBar2: () => ChartBar2_default,
  chartBar22X: () => ChartBar22X_default,
  chartBar3: () => ChartBar3_default,
  chartSmall: () => ChartSmall_default,
  chartSmall2X: () => ChartSmall2X_default,
  check: () => Check_default,
  check2X: () => Check2X_default,
  checkCircle: () => CheckCircle_default,
  checkPhone: () => CheckPhone_default,
  checkRound: () => CheckRound_default,
  chevronDown: () => ChevronDown_default,
  chevronLeft: () => ChevronLeft_default,
  chevronRight: () => ChevronRight_default,
  chevronRight2X: () => ChevronRight2X_default,
  chevronUp: () => ChevronUp_default,
  clock: () => Clock_default,
  clock24: () => Clock24_default,
  close: () => Close_default,
  closeRound: () => CloseRound_default,
  cnn: () => Cnn_default,
  coil: () => Coil_default,
  contactless: () => Contactless_default,
  contactlessCard: () => ContactlessCard_default,
  coupon: () => Coupon_default,
  creditCard: () => CreditCard_default,
  customerSupport: () => CustomerSupport_default,
  customerSupport2X: () => CustomerSupport2X_default,
  cutlery: () => Cutlery_default,
  dateCalendar: () => DateCalendar_default,
  dateCalendar2X: () => DateCalendar2X_default,
  dateClock: () => DateClock_default,
  dateClock2X: () => DateClock2X_default,
  dollarCircle: () => DollarCircle_default,
  dollarInvoicePay: () => DollarInvoicePay_default,
  dollarInvoicePay2X: () => DollarInvoicePay2X_default,
  dollarOff: () => DollarOff_default,
  dollarOff2X: () => DollarOff2X_default,
  dollarPaymentLink: () => DollarPaymentLink_default,
  dollarPaymentLink2X: () => DollarPaymentLink2X_default,
  dollarPhone: () => DollarPhone_default,
  dollarPhone2X: () => DollarPhone2X_default,
  dollarShield: () => DollarShield_default,
  dollarShield2X: () => DollarShield2X_default,
  dollarSign: () => DollarSign_default,
  dollarSign2X: () => DollarSign2X_default,
  duoStars: () => DuoStars_default,
  eCart: () => ECart_default,
  eCart2X: () => ECart2X_default,
  eCommerce: () => ECommerce_default,
  ecommerce2X: () => Ecommerce2X_default,
  economicoValor: () => EconomicoValor_default,
  email: () => Email_default,
  email2X: () => Email2X_default,
  faceHappy: () => FaceHappy_default,
  faceHappy2X: () => FaceHappy2X_default,
  file: () => File_default,
  file2X: () => File2X_default,
  fileTyped: () => FileTyped_default,
  financeAndStone: () => FinanceAndStone_default,
  flipUp: () => FlipUp_default,
  flipUp2: () => FlipUp2_default,
  formHeart2X: () => FormHeart2X_default,
  formStar: () => FormStar_default,
  formStar2X: () => FormStar2X_default,
  gift: () => Gift_default,
  global: () => Global_default,
  grid: () => Grid_default,
  grid2: () => Grid2_default,
  handHeart: () => HandHeart_default,
  handHeart2X: () => HandHeart2X_default,
  handHeartSoft: () => HandHeartSoft_default,
  handMoney: () => HandMoney_default,
  handShake: () => HandShake_default,
  handShake2X: () => HandShake2X_default,
  handshakeSoft: () => HandshakeSoft_default,
  headPhone: () => HeadPhone_default,
  headset: () => Headset_default,
  healthFaceHappy: () => HealthFaceHappy_default,
  heart: () => Heart_default,
  heart24: () => Heart24_default,
  helpInfo: () => HelpInfo_default,
  helpInfo2X: () => HelpInfo2X_default,
  hospital: () => Hospital_default,
  hospital2X: () => Hospital2X_default,
  info: () => Info_default,
  invoice2: () => Invoice2_default,
  invoice22X: () => Invoice22X_default,
  libras: () => Libras_default,
  lifeBuoy: () => LifeBuoy_default,
  link: () => Link_default,
  link2X: () => Link2X_default,
  lock: () => Lock_default,
  logo: () => Logo_default,
  logoRaioX: () => LogoRaioX_default,
  logoRaioX2X: () => LogoRaioX2X_default,
  logoStone: () => LogoStone_default,
  logoStone2X: () => LogoStone2X_default,
  logoTon: () => LogoTon_default,
  logoTonStone: () => LogoTonStone_default,
  logoWhatsapp: () => LogoWhatsapp_default,
  logoWhatsapp2X: () => LogoWhatsapp2X_default,
  loyaltyHeart2X: () => LoyaltyHeart2X_default,
  machine: () => Machine_default,
  mail: () => Mail_default,
  message: () => Message_default,
  message2X: () => Message2X_default,
  minus: () => Minus_default,
  minusCircle: () => MinusCircle_default,
  mobileBanking: () => MobileBanking_default,
  mobileCard: () => MobileCard_default,
  mobilePhone: () => MobilePhone_default,
  money: () => Money_default,
  money2X: () => Money2X_default,
  moneyGrowth: () => MoneyGrowth_default,
  moneyHand: () => MoneyHand_default,
  moneyHand24: () => MoneyHand24_default,
  moneyHand2X: () => MoneyHand2X_default,
  moneyTime: () => MoneyTime_default,
  office: () => Office_default,
  office2X: () => Office2X_default,
  oneStars: () => OneStars_default,
  openBook: () => OpenBook_default,
  papoDeBalcao: () => PapoDeBalcao_default,
  pause: () => Pause_default,
  paymentLink: () => PaymentLink_default,
  peopleHandshake: () => PeopleHandshake_default,
  peopleQuestion: () => PeopleQuestion_default,
  phone: () => Phone_default,
  phone2X: () => Phone2X_default,
  phoneCard: () => PhoneCard_default,
  phoneCard2X: () => PhoneCard2X_default,
  phoneChat: () => PhoneChat_default,
  phoneChat2X: () => PhoneChat2X_default,
  phoneCheck: () => PhoneCheck_default,
  phoneMobile: () => PhoneMobile_default,
  phoneOutgoing: () => PhoneOutgoing_default,
  phoneSmart2X: () => PhoneSmart2X_default,
  pig: () => Pig_default,
  pill: () => Pill_default,
  pix: () => Pix_default,
  play: () => Play_default,
  playBorder: () => PlayBorder_default,
  plus: () => Plus_default,
  plusCircle: () => PlusCircle_default,
  pos: () => Pos_default,
  pos2X: () => Pos2X_default,
  posCoil: () => PosCoil_default,
  posQr: () => PosQr_default,
  posQr2X: () => PosQr2X_default,
  posReceiptList2X: () => PosReceiptList2X_default,
  posSmall: () => PosSmall_default,
  pounds: () => Pounds_default,
  puzzle: () => Puzzle_default,
  qrCode: () => QrCode_default,
  qrCode2X: () => QrCode2X_default,
  qrCodePix: () => QrCodePix_default,
  question: () => Question_default,
  raioX: () => RaioX_default,
  rateDown: () => RateDown_default,
  rateDown2X: () => RateDown2X_default,
  receiptList43: () => ReceiptList43_default,
  reclameAqui: () => ReclameAqui_default,
  rings: () => Rings_default,
  roundDollar: () => RoundDollar_default,
  scan: () => Scan_default,
  securityKey: () => SecurityKey_default,
  securityKey2X: () => SecurityKey2X_default,
  securityLock: () => SecurityLock_default,
  securityLock2X: () => SecurityLock2X_default,
  securityShield: () => SecurityShield_default,
  securityShield2X: () => SecurityShield2X_default,
  sendMessage: () => SendMessage_default,
  share: () => Share_default,
  shop2: () => Shop2_default,
  signalContactless: () => SignalContactless_default,
  signalContactless2X: () => SignalContactless2X_default,
  signalFormStar: () => SignalFormStar_default,
  signalLoader: () => SignalLoader_default,
  signalPercent: () => SignalPercent_default,
  signalWifi2: () => SignalWifi2_default,
  simCard: () => SimCard_default,
  sliders: () => Sliders_default,
  smartPhone: () => SmartPhone_default,
  star24: () => Star24_default,
  stone: () => Stone_default,
  stoneAgent: () => StoneAgent_default,
  stoneAgentShakingHands: () => StoneAgentShakingHands_default,
  stoneAgentShakingHands2X: () => StoneAgentShakingHands2X_default,
  storeShop: () => StoreShop_default,
  swapHorizontal: () => SwapHorizontal_default,
  tag: () => Tag_default,
  tagLoyalty: () => TagLoyalty_default,
  telephone: () => Telephone_default,
  tool: () => Tool_default,
  toolSettings: () => ToolSettings_default,
  toolSettings2X: () => ToolSettings2X_default,
  user2X: () => User2X_default,
  userCheck: () => UserCheck_default,
  userCheck2X: () => UserCheck2X_default,
  userCustomerSupport: () => UserCustomerSupport_default,
  userCustomerSupport2X: () => UserCustomerSupport2X_default,
  userUsers: () => UserUsers_default,
  userUsers2X: () => UserUsers2X_default,
  users: () => Users_default,
  users2X: () => Users2X_default,
  whatsapp: () => Whatsapp_default,
  zap: () => Zap_default,
  zapOff2X: () => ZapOff2X_default
});

export {
  icons_exports
};
